module.exports = __webpack_public_path__ + "img/breaking-hits-logo.fb3f769a.png";